import axios from "axios";
import React, { useEffect, useState } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getAccessToken } from "../../../storage/storage";
import { OtherInvoiceSkeleton } from "../../../components/Skeletons";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { FormatDate } from "../../../utils/FormateDate";
import { getApiErrorMessage } from "../../../utils/apiError";

const OtherInvoice = () => {
  const token = getAccessToken();
  const { guestStayId } = useParams();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [invoice, setInvoice] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${BASE_URL}/api/invoices/property/?property_id=${guestStayId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setInvoice(response.data);
      } catch (err) {
        console.error(err);
        setError(getApiErrorMessage(err, "Failed to load invoice data"));
      } finally {
        setLoading(false);
      }
    };

    fetchInvoice();
  }, [guestStayId, BASE_URL, token]);

  return (
    <div className="flex lg:flex-row flex-col lg:items-start items-center px-6 w-full h-full">
      <div className="lg:px-10 px-4 mt-8 mb-16 h-[100vh] w-full">
        <Link
          to="/other-tasks"
          className="flex items-center gap-2 text-xl font-bold text-[#586989] hover:text-blue-600"
        >
          <IoMdArrowBack />
          <p>Back</p>
        </Link>

        <div className="relative mt-4 pb-5">
          <div className="border border-[#DFDFDF] bg-white rounded-lg shadow-md overflow-auto h-[70vh] w-full">
            <table className="w-full border-collapse min-w-[600px]">
              <thead className="sticky top-0 bg-[#FFF5CE] text-[#586989] z-10">
                <tr>
                  <th className="p-2 text-center min-w-[150px]">Clean Date</th>
                  <th className="p-4 text-center min-w-[150px]">Cleaner Name</th>
                  <th className="py-3 px-4 min-w-[150px] text-center">Address</th>
                  <th className="py-3 px-4 min-w-[150px] text-center">Invoice Status</th>
                  <th className="py-3 px-4 min-w-[150px] text-center">Action Date</th>
                  <th className="p-2 text-center min-w-[150px]">View Invoice</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <OtherInvoiceSkeleton />
                ) : error ? (
                  <tr>
                    <td colSpan="7" className="text-center text-red-500 h-[400px]">
                      {error}
                    </td>
                  </tr>
                ) : invoice?.length > 0 ? (
                  invoice.map((stay, index) => (
                    <tr key={index} className="border-b">
                      <td className="px-4 py-6 text-center">{FormatDate(stay.created_at)}</td>
                      <td className="px-4 py-6 text-center">{stay.cleaner_name}</td>
                      <td className="px-4 py-6 text-center">
                        {stay?.property?.address_line_1}, {stay?.property?.city},{" "}
                        {stay?.property?.country}
                      </td>
                      <td className="px-4 py-6 text-center">
                        {stay?.status ? stay.status.toUpperCase() : "-"}
                      </td>
                      <td className="px-4 py-6 text-center">
                        {stay?.status === "approved" ||
                        stay?.status === "paid" ||
                        stay?.status === "rejected"
                          ? stay?.action_date
                            ? FormatDate(stay.action_date)
                            : "-"
                          : "-"}
                      </td>
                      <td className="px-4 py-6 text-center">
                        <div
                          onClick={() => navigate(`/invoice-detail/${stay.id}`)}
                          className="flex items-center justify-center cursor-pointer"
                        >
                          <MdOutlineRemoveRedEye />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center text-lg font-bold text-[#586989] h-[400px]"
                    >
                      No Invoice found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherInvoice;
